import { isDate } from "date-fns"
import { storageName } from "shared/constants/storage-constant"

export function hasPermission(userPermissions, moduleName, functionName) {
  let permissionName = `Express${functionName == "CompanySelect" ? functionName : "AllAccess"}`.toLowerCase()
  return userPermissions.find(x => x.Permission_Name.toLowerCase() == permissionName) !== undefined
}

export function transformObjectKeys(input, toLowerCase = true) {
  if (typeof input !== "object") return input
  if (Array.isArray(input)) return input.map(x => transformObjectKeys(x, toLowerCase))
  return Object.keys(input).reduce(function (newObj, key) {
    let val = input[key]
    let newVal = typeof val === "object" && val !== null && !isDate(val) ? transformObjectKeys(val, toLowerCase) : val
    newObj[toLowerCase ? key.toLowerCase() : key.toUpperCase()] = newVal
    return newObj
  }, {})
}

export function twoDecimalPlace(string) {
  if (string === null) return ""

  if (string && string !== "") {
    const newFloat = parseFloat(string)
    return newFloat.toString().match(/^-?\d+(?:\.\d{0,2})?/)
  }
  return ""
}

export function genId() {
  return Math.floor(Math.random() * Date.now())
}

export function isItemBOM(el) {
  return el?.item_type === "B"
}

// Marks the component lines of each BOM line in a saved order. Saved orders carry nothing linking a component
// line to its BOM (all lines come back numbered 1, 2, 3...), so the BOM's definition is used: each component
// is the first unclaimed, non-BOM line after the BOM line with that SKU.
// definitions[i] is the BOM definition ([{ ITEM, QTY_NEEDED_PER_ITEM }]) for bomLines[i].
export function linkBomComponents(lines, bomLines, definitions) {
  const claimed = new Set()
  bomLines.forEach((bom, i) => {
    const components = Array.isArray(definitions[i]) ? definitions[i] : []
    components.forEach(component => {
      const sku = String(component.ITEM || "").toUpperCase()
      const line = lines.find(x => !claimed.has(x) && !isItemBOM(x) && Number(x.line_num) > Number(bom.line_num) && String(x.product || "").toUpperCase() === sku)
      if (!line) return
      claimed.add(line)
      line.parentProduct = bom.product
      line.qty_per_item = Number(component.QTY_NEEDED_PER_ITEM) || 0
    })
  })
  return lines
}

export function getModuleName(filterStorageName) {
  if (filterStorageName == storageName.salesOrderFilter) return "SaleOrder"
  else if (filterStorageName == storageName.inboundFilter) return "ASN"
  else if (filterStorageName == storageName.inventoryFilter) return "Inventory"
  else if (filterStorageName == storageName.returnsFilter) return "Returns"

  return ""
}
